import { IPagination } from 'app/types/common';

export interface IPayoutLineItem {
  fullName: string;
  email: string;
  mobile: string;
  createdAt: Date;
  updatedAt: Date;
  status: null;
  teamName: string;
  team: {
    id: string;
  };
  consumer: {
    id: string;
  };
  financialStatus: string;
  pendingTeamPaymentCollectionsTotalCount: number;
  paidTeamPaymentCollectionsTotalCount: number;
  overdueTeamPaymentCollectionsTotalCount: number;
  pendingTeamPaymentCollectionsTotalAmount: number;
  paidTeamPaymentCollectionsTotalAmount: number;
  overdueTeamPaymentCollectionsTotalAmount: number;
}
export interface IPayoutLineItemsState {
  readonly payoutLineItemsById?: any;
  readonly payoutLineItemIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly showAddPayoutLineItem?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationPayoutLineItemIds?: string[];
  readonly currentPayoutLineItemId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IPayoutLineItemsSelector extends IPayoutLineItemsState {
  readonly currentPayoutLineItem?: any;
  readonly currentFormPayoutLineItem?: any;
  readonly getPayoutLineItemsFilteredByTagInSelectFormat?: any;
  readonly payoutLineItemsByIdInSelectFormat?: any;
}

export enum PayoutLineItemsActionTypes {
  GET_ALL_PAYOUT_LINE_ITEMS_REQUESTED = 'redux-app/payout-line-items/GET_ALL_PAYOUT_LINE_ITEMS_REQUESTED',
  GET_ALL_PAYOUT_LINE_ITEMS_PENDING = 'redux-app/payout-line-items/GET_ALL_PAYOUT_LINE_ITEMS_PENDING',
  GET_ALL_PAYOUT_LINE_ITEMS_SUCCESS = 'redux-app/payout-line-items/GET_ALL_PAYOUT_LINE_ITEMS_SUCCESS',
  GET_ALL_PAYOUT_LINE_ITEMS_FAIL = 'redux-app/payout-line-items/GET_ALL_PAYOUT_LINE_ITEMS_FAIL',
  GET_PAYOUT_LINE_ITEM_REQUESTED = 'redux-app/payout-line-items/GET_PAYOUT_LINE_ITEM_REQUESTED',
  GET_PAYOUT_LINE_ITEM_PENDING = 'redux-app/payout-line-items/GET_PAYOUT_LINE_ITEM_PENDING',
  GET_PAYOUT_LINE_ITEM_SUCCESS = 'redux-app/payout-line-items/GET_PAYOUT_LINE_ITEM_SUCCESS',
  GET_PAYOUT_LINE_ITEM_FAIL = 'redux-app/payout-line-items/GET_PAYOUT_LINE_ITEM_FAIL',
  UPDATE_PAYOUT_LINE_ITEM_REQUESTED = 'redux-app/payout-line-items/UPDATE_PAYOUT_LINE_ITEM_REQUESTED',
  UPDATE_PAYOUT_LINE_ITEM_PENDING = 'redux-app/payout-line-items/UPDATE_PAYOUT_LINE_ITEM_PENDING',
  UPDATE_PAYOUT_LINE_ITEM_SUCCESS = 'redux-app/payout-line-items/UPDATE_PAYOUT_LINE_ITEM_SUCCESS',
  UPDATE_PAYOUT_LINE_ITEM_FAIL = 'redux-app/payout-line-items/UPDATE_PAYOUT_LINE_ITEM_FAIL',
  CREATE_PAYOUT_LINE_ITEM_REQUESTED = 'redux-app/payout-line-items/CREATE_PAYOUT_LINE_ITEM_REQUESTED',
  CREATE_PAYOUT_LINE_ITEM_PENDING = 'redux-app/payout-line-items/CREATE_PAYOUT_LINE_ITEM_PENDING',
  CREATE_PAYOUT_LINE_ITEM_SUCCESS = 'redux-app/payout-line-items/CREATE_PAYOUT_LINE_ITEM_SUCCESS',
  CREATE_PAYOUT_LINE_ITEM_FAIL = 'redux-app/payout-line-items/CREATE_PAYOUT_LINE_ITEM_FAIL',
  DELETE_PAYOUT_LINE_ITEM_REQUESTED = 'redux-app/payout-line-items/DELETE_PAYOUT_LINE_ITEM_REQUESTED',
  DELETE_PAYOUT_LINE_ITEM_PENDING = 'redux-app/payout-line-items/DELETE_PAYOUT_LINE_ITEM_PENDING',
  DELETE_PAYOUT_LINE_ITEM_SUCCESS = 'redux-app/payout-line-items/DELETE_PAYOUT_LINE_ITEM_SUCCESS',
  DELETE_PAYOUT_LINE_ITEM_FAIL = 'redux-app/payout-line-items/DELETE_PAYOUT_LINE_ITEM_FAIL',
  SELECT_PAYOUT_LINE_ITEM_REQUESTED = 'redux-app/payout-line-items/SELECT_PAYOUT_LINE_ITEM_REQUESTED',
  CLEAR_PAYOUT_LINE_ITEMS = 'redux-app/payout-line-items/CLEAR_PAYOUT_LINE_ITEMS',
}

export default null;
